import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseRentIndexationSkippedTemplates = [
  {
    id: '-222001',
    language: Language.EN,
    subject: "Your lease won't be indexed this year",
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>No indexation will be applied to your lease this year.</p>
          <p>The rent will remain unchanged at {{lease.totalRentalPrice}} € and the charges at {{getLeaseCurrentMonthlyCharges lease}} €.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-222002',
    language: Language.FR,
    subject: 'Votre bail ne sera pas indexé cette année',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Aucune indexation ne sera appliquée à votre bail cette année.</p>
          <p>Le loyer restera inchangé à {{lease.totalRentalPrice}} € et les charges à {{getLeaseCurrentMonthlyCharges lease}} €.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-222003',
    language: Language.NL,
    subject: 'Indexering huur',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Er wordt dit jaar geen indexering op uw huurcontract.</p>
          <p>De huur blijft ongewijzigd op {{lease.totalRentalPrice}} € en de kosten op {{getLeaseCurrentMonthlyCharges lease}} €.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-222004',
    language: Language.DE,
    subject: 'Ihre Miete wird dieses Jahr nicht indexiert',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Auf Ihren Mietvertrag wird dieses Jahr keine Indexierung angewendet.</p>
          <p>Die Miete bleibt unverändert bei {{lease.totalRentalPrice}} € und die Nebenkosten bei {{getLeaseCurrentMonthlyCharges lease}} €.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
